import { render, staticRenderFns } from "./PostSchool.vue?vue&type=template&id=f850aaa8&"
import script from "./PostSchool.vue?vue&type=script&lang=js&"
export * from "./PostSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports